import React from 'react';
import PropTypes from 'prop-types';
import { Button, Segment } from 'semantic-ui-react';
import classnames from 'classnames';
import 'semantic-ui-css/components/button.min.css';
import 'semantic-ui-css/components/segment.min.css';
import './credit-card-information.css';
import { COUNTRY_CODES } from '../strings.js';

export default class CreditCardInformation extends React.PureComponent {
  constructor(props) {
    super(props);
    this.initialState = {
      errors: {},
      firstName: props.firstName,
      lastName: props.lastName,
      address1: props.address1,
      address2: props.address2,
      city: props.city,
      state: props.state,
      country: props.country || 'US',
      postalCode: props.postalCode,
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    window.recurly &&
      window.recurly.configure({
        publicKey: 'ewr1-1kUNNu6RTLUzdB0tivupyc',
        fields: {
          all: {
            style: {
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              invalid: {
                fontColor: 'red',
              },
              placeholder: {
                color: 'rgba(200,200,200) !important',
              },
            },
          },
          card: {
            inputType: 'mobileSelect',
          },
          number: {
            style: {
              placeholder: {
                content: 'XXXX XXXX XXXX XXXX',
              },
            },
          },
          month: {
            inputType: 'select',
            style: {
              placeholder: {
                content: 'MM',
              },
            },
          },
          year: {
            inputType: 'select',
            style: {
              placeholder: {
                content: 'YYYY',
              },
            },
          },
          cvv: {
            style: {
              placeholder: {
                content: 'CVV',
              },
            },
          },
        },
      });
  }

  handleToken = (token) => {
    this.props.onToken(token.id);
  };

  validate = () => {
    return true;
  };

  handleFieldChange = (name) => {
    return (e) => {
      let newState = {};
      newState[name] = e.target.value;
      this.setState(() => {
        return newState;
      });
    };
  };

  handleSubmit = (event) => {
    this.setState({ errors: this.initialState.errors });
    event.preventDefault();
    if (!this.validate()) return;
    this.props.onSubmit(this.form);

    window.recurly.token(this.form, (err, token) => {
      if (err) {
        const errObj = err.details.reduce((acc, val) => {
          acc[val.field] = val.messages;
          return acc;
        }, {});
        this.setState({ errors: errObj });
      } else {
        this.handleToken(token);
      }
    });
  };

  renderErrors = (field) => {
    if (this.state.errors[field]) {
      return (
        <span className="cc-form__error-message">
          * {this.state.errors[field].join(', ')}
        </span>
      );
    }
    return null;
  };

  render() {
    return (
      <Segment basic className="cc-form" loading={this.props.loading}>
        <form
          className={classnames('ui form', {
            loading: this.props.loading,
          })}
          onSubmit={this.handleSubmit}
          ref={(form) => (this.form = form)}>
          <div className="cc-form__row">
            <div className="cc-form__field col_6">
              <label>First Name</label>
              {this.renderErrors('first_name')}
              <input
                type="text"
                data-recurly="first_name"
                placeholder="First Name"
                autoComplete="cc-given-name"
                onChange={this.handleFieldChange('firstName')}
                value={this.state.firstName}
              />
            </div>
            <div className="cc-form__field col_6">
              <label>Last Name</label>
              {this.renderErrors('last_name')}
              <input
                type="text"
                data-recurly="last_name"
                placeholder="Last Name"
                autoComplete="cc-family-name"
                onChange={this.handleFieldChange('lastName')}
                value={this.state.lastName}
              />
            </div>
          </div>
          <div className="cc-form__row">
            <div className="cc-form__field col_12" style={{ flex: '2.11' }}>
              <label>Address</label>
              {this.renderErrors('address1')}
              <input
                type="text"
                data-recurly="address1"
                placeholder="Street Address"
                onChange={this.handleFieldChange('address1')}
                value={this.state.address1}
              />
            </div>
            <div className="cc-form__field col_4" style={{ flex: '1' }}>
              <label>Suite/Apt</label>
              {this.renderErrors('address2')}
              <input
                type="text"
                data-recurly="address2"
                placeholder="Suite/#"
                onChange={this.handleFieldChange('address2')}
                value={this.state.address2}
              />
            </div>
          </div>
          <div className="cc-form__row">
            <div className="cc-form__field col_8" style={{ flex: '2' }}>
              <label>City</label>
              {this.renderErrors('city')}
              <input
                type="text"
                data-recurly="city"
                placeholder="Street Address"
                onChange={this.handleFieldChange('city')}
                value={this.state.city}
              />
            </div>
            <div className="cc-form__field col_4" style={{ flex: '2' }}>
              <label>State/Region</label>
              {this.renderErrors('state')}
              <input
                type="text"
                data-recurly="state"
                placeholder="State"
                onChange={this.handleFieldChange('state')}
                value={this.state.state}
              />
            </div>
            <div className="cc-form__field col_4" style={{ flex: '2' }}>
              <label>Country</label>
              {this.renderErrors('country')}
              <select
                data-recurly="country"
                placeholder="Country"
                onChange={this.handleFieldChange('country')}
                value={this.state.country}>
                {COUNTRY_CODES.map((country) => (
                  <option key={country.key} value={country.value}>
                    {country.text}
                  </option>
                ))}
              </select>
            </div>
            <div className="cc-form__field col_4" style={{ flex: '2' }}>
              <label>Postal Code</label>
              {this.renderErrors('postal_code')}
              <input
                type="text"
                data-recurly="postal_code"
                placeholder="Zip"
                onChange={this.handleFieldChange('postalCode')}
                value={this.state.postalCode}
              />
            </div>
          </div>
          <div className="cc-form__row">
            <div className="cc-form__field col_12">
              <label>Card Number</label>
              {this.renderErrors('number')}
              {this.renderErrors('month')}
              {this.renderErrors('year')}
              {this.renderErrors('cvv')}
              <div data-recurly="card"></div>
            </div>
          </div>
          <input type="hidden" name="recurly-token" data-recurly="token" />
          {Object.keys(this.state.errors).length > 0 && (
            <div className="cc-form__error-message cc-form__error-message--top">
              Submission failed, see above for details
            </div>
          )}
          {this.props.children}
          {this.props.renderSubmitButton && (
            <div className="cc-form__row">
              <div className="cc-form__field col_12">
                <Button primary>Save</Button>
                {this.props.renderCancelButton && (
                  <Button
                    className="tertiary"
                    type="button"
                    floated="right"
                    onClick={this.props.onCancel}>
                    Cancel
                  </Button>
                )}
              </div>
            </div>
          )}
        </form>
      </Segment>
    );
  }
}

CreditCardInformation.propTypes = {
  loading: PropTypes.bool,
  renderSubmitButton: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onToken: PropTypes.func.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  postalCode: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string.isRequired,
  renderCancelButton: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
};

CreditCardInformation.defaultProps = {
  loading: false,
  renderSubmitButton: true,
  onSubmit: function () {},
  onToken: function () {},
  renderCancelButton: false,
  onCancel: function () {},
};
